// 按页面划分
export default {
  // 公共页面
  common: {
    title:"流量商城",
    pull_refresh: '下拉刷新',
    release_refresh: '鬆開刷新',
    refresh_loading: '刷新中...',
    footer_text: '服務由 Ucloudlink（NASDAQ: UCL）提供'
  },
  home: {
    input_placeholder: '搜索國家/地區',
    my_flow: '我的流量',
    charge_code: '充值卡',
    coupons:'優惠券',
    local_package: '本地流量',
    more: '更多',
    popular_destination: '國家/地區',
    buy_now: '購買',
    package_useing: '使用中',
    unused: '待使用',
    download_app: '下載APP',
    enter_the_mall_list: '進入商城列表',
    no_data: '暫無數據',
    no_data_available: '暫無可用套餐',
    copy_success: '複製成功',
    copy_fail: '複製失敗',
    meritsTitle: '產品優勢',
    merits1: '無需辦卡、無月租',
    merits2: '內置top 2~3 運營商，自動切換網絡',
    go_buy: '去購買',
    instant_savings: '立省',
    expires_in: '剩',
    download_app_tips: '下載APP獲得更多優惠與體驗'
  },
  packages: {
    sub_title: {
      us: '關島、塞班島除外',
      it: '適用梵蒂岡、聖馬力諾',
      va: '適用意大利、聖馬力諾',
      sm: '適用意大利、梵蒂岡',
      ma: '適用西撒哈拉',
      eh: '適用摩洛哥',
      ch: '適用列支敦士登',
      li: '適用瑞士',
      fr: '適用摩納哥',
      mc: '適用法國',
      fi: '適用奧蘭群島',
      ax: '適用芬蘭',
      gu: '適用塞班島',
      mp: '適用關島'
    },
    unlimited_packages: '無限數據套餐',
    normal_packages: '普通數據套餐',
    multi_region_packages: '跨区域',
    regional_data: '區域流量',
    high_speed_text: '高速流量',
    infiniteFlow:'無限流量',
    unLimitData: '無限量',
    high_speed_text_year: '高速流量/月',
    package_list: '套餐列表',
    special_offer: '特賣',
    first_month: '首月',
    periodUnit: {
      day: '天',
      month: '月',
      hour: '小時',
      year: '年',
    },
    periodUnits: {
      day: '天',
      month: '個月',
      hour: '小時',
      year: '年',
    },
    periodUnitSimp: {
      day: '天',
      month: '月',
      hour: '小時',
      year: '年',
    },
    periodUnitMonthly:'每月',
    periodUnitsSimp: {
      day: '天',
      month: '個月',
      hour: '小時',
      year: '年',
    },
    unlimited_good_name: {
      day: '包天暢享',
      month: '月暢享',
      year: '年暢享'
    },
    continuousMonth : "連續包月",
    continuousDay : "連續包天",
    continuousYear:"連續包年",
    day_invalid: '當天失效',
    month_invalid: '當月失效',
    immediate_valid: '立即生效',
    tomorrow_day_valid: '次日生效',
    tomorrow_month_valid: '次月生效',

    // detail page
    detail: {
      cell_flow: '數據',
      cell_period: '有效期',
      buy_quantity: '購買份數',
      use_area: '適用區域',
      use_intro: '使用須知',
      buy_btn: '訂購',
      pay: '支付',
      buy_tips: '您有%@packageName套餐正在使用，是否確定購買此套餐？',
      haveOrderTips: "您已生成待支付訂單，點擊確認前往我的流量頁面查看！"
    },

    // confirm page
    confirm: {
      title: '確認訂單',
      real_pay_amount: '金額',
      online_payment: '在綫支付',
      create_order_error: '創建訂單失敗'
    }
  },

  pay: {
    // result page
    result: {
      loading_order_status: '正在獲取訂單狀態……',
      buy_success: '訂購成功',
      buy_pending: '正在確認',
      buy_pending_tip: '支付結果確認中，如10分鐘後還未到賬，請諮詢客服。',
      get_payment_info_fail: '支付信息獲取失敗',
      cell_package: '套餐包',
      cell_buy_amount: '支付金額',
      cell_real_amount: '金額',
      go_to_order_btn: '查看我的流量',
      back_home: '返回首頁',
      back_mall: '返回商城',
      ordersn_empty: 'Order SN 為空',
      order_search_error: '沒有查詢到相關訂單信息',
      goodsName:"商品名",
    },

    //fail page
    fail: {
      payment_fail: '支付失敗',
      payment_fail_desc: '請返回商品頁面，重新購買',
      back_home: '返回首頁'
    },
  },
  order: {
    state: {
      inUse: '使用中',
      isFirst: '已優先',
      toFirst: '優先',
      inactive: '未激活'
    },
    periodUnits: {
      minute: '分鐘',
      hour: '小時',
      day: '天',
      month: '個月',
    },
    useIntro: {
      tip1: '暢享套餐的使用等級高於定額套餐;',
      tip2: '同類型套餐則按照購買先後次序為基本原則, 而單國套餐較跨國套餐優先使用;',
      tip3: '您也可以在APP內手動調整同類型套餐的使用次序。'
    },
    myFlow: '我的流量',
    remainingFlow: '剩餘流量',
    remainingTime: '剩餘時間',
    remainingHighFlow: '剩餘高速',
    validPeriod: '有效期',
    noneFlow: '暫無流量包',
    noneFlowTip: '購買流量包去享受優質網絡吧',
    buyPackFlow: '購買套餐',
    checkInvalidFlow: '查看失效流量包',
    orderList: {
      title: '我的訂單',
      amount_paid: '實付金額',
      device: '所屬設備',
      order_details: '訂單詳情',
      total_amont: '總價',
      orderSN: '訂單編號',
      createTime: '創建時間',
      cancelTime: '取消時間',
      payTime: '支付時間',
      unsubTime: '退訂時間',
      payMethod: '支付方式',
      thirdSN: '交易流水號',
      delete: '刪除',
      cancel: '取消訂單',
      unsub: '退訂',
      goto_cancel: '是否取消訂單?',
      goto_unsubscribe: '是否退訂訂單?',
      delete_Tips: '刪除後訂單無法恢復，無法處理您的售後問題，確定是否刪除？',
      status_success: '已完成',
      status_pending: '等待支付',
      status_cancel: '已取消',
      status_unsub: '已退訂',
      payMethod_stripe: '信用卡'
    }
  },
  registerlogin: {
    create_account_tip:'創建帳戶，開啟您的專屬體驗',
    select_country_tip:'設備使用國家或地區',
    email_name: "郵箱",
    phone_name: "智慧型手機",
    email_address: "郵箱地址",
    password: "密碼",
    country: "國家",
    select_country: "選擇國家",
    cancel: "取消",
    confirm: "確定",
    please_enter: "請輸入6-20個字符（字母、數字或符號的組合）",
    select_country_tips: "國家用於展示該國套餐，註冊後不可修改，請確認！",
    global_roaming: "國際區號",
    phone_number: "手機號碼",
    agree: "同意",
    user_agreement: "用戶協議",
    and: "和",
    privacy_policy: "隱私政策",
    register_login: "註冊或登錄",
    login_error: "登陸次數過於頻繁，請稍後重試！",
    register_error: "註冊次數過於頻繁，請稍後重試！",
    forgot_pwd: "忘記密碼",
    app_tips: "此賬號可通過下載app登陸，獲得更多功能。",
    download_app: "去下載APP",
    rememberPwd: "記住密碼",
    third_login: "其他登入方式",
    agreement_tips: "請勾選 用戶協議 和 隱私權政策 ",
    selectCountry_tips: "請注意，註冊國家將直接影響您未來的支付方式和幣種。請根據個人需求，謹慎選擇。",
    login_error_cancel: "用戶取消了登入",
    login_error_auth: "請允許瀏覽器彈出視窗",
    device_tips: "設備正在等待啟動，感謝您的耐心等待，我們將在 24 小時內處理完畢。"
  },
  forgotPwd: {
    forgot_pwd: "忘記密碼",
    email_address: "郵箱地址",
    next: "下一步",
    email_has_been_sent: "我們已發送一封電子郵件到%@email。請點擊其中的鏈接，並按步驟操作來找回您的密碼。",
    have_retrieved_it: "我已找回",
    unable_to_receive_email: "收不到郵件？請檢查您的垃圾郵件和已刪除郵件目錄下是否有來自 %@email 的郵件",
    or: "或",
    resend: "重新發送",
    global_roaming: "國際區號",
    phone_number: "手機號碼",
    verification_code_has_been_sent: "我們已發送驗證碼至:",
    verification_code: "驗證碼",
    no_verification_code_received: "沒有收到驗證碼?",
    please_enter: "請輸入6-20個字符（字母、數字或符號的組合）",
    reset_password: "重置密碼",
    reset_successful: "重置成功"
  },
  coupons: {
    coupons_name: "優惠券",
    no_coupons: "暫無優惠券",
    no_data: "暫無數據",
    applicable_to_the_following: "優惠券適用於以下流量"
  },
  digital:{
      title:"設備 SN",
      purchased:"已購產品",
      viewAll:"查看全部",
      skinStore:"產品商店",
      completed:"已購買",
      goBuy:"購買",
      order: {
        title:"已購訂單"
      },
      detail: {
        describe:"描述"
      }
  },
  viewPL: {
    other: '其他'
  },
  invalidFlow: {
    stateName: '狀態',
    state: {
      NOT_ACTIVATED: "未激活",
      IN_USING: "可使用",
      USE_END: "已用完",
      EXPIRE: "已到期",
      TRANSFER: "已轉移",
      UNSUBSCRIBE: "退訂",
      VALID: "有效",
      INVALID: "無效",
      EXCHANGE_POINTS: "兌換積分"
    },
    noneFlow: '暫無失效流量包',
    pageName: '失效流量包'
  },
  CountryGroup: {
    title: "國家/地區",
    placeholder: "搜索國家/地區",
    clear: "清除",
    history: "歷史數據"
  },
  PromotionCode: {
    verification: {
      title: '充值卡',
      minititle:'充值碼',
      input: '請輸入充值碼',
      explain: '說明：點擊掃描圖標和掃描儲值卡的二維碼，或者手動輸入（注意字母大小寫區別）',
      submit: '提交',
      exchange: '兌換',
      cancel: '取消',
      ErrorCode: '充值碼錯誤',
      Inquiry: "確認要兌換",
    },
    recharge_success: {
      package: '流量包',
      content: '成功兌換了',
      back: '返回商城',
      view_packets: '查看我的流量'
    }
  },
  flowDetail: {
    title: '流量詳情',
    flow: '流量',
    validTime: '生效時間',
    invalidTime: '失效時間',
    coverage: '適用區域',
    useIntro: '使用須知',
    purchaseTime: '購買時間',
    subtotal: '支付金額',
    status: '狀態',
    cancel: '退訂',
    buyAgain: '再次購買',
    validity: '有效期',
    tip: '温馨提示',
    cancelTip: '確認退訂?',
    dataLeft: '剩餘'
  },
  netError: {
    try_again: '重試',
    net_error: '無網絡',
    try_again_desc: '請檢查網絡設置後再試試'
  },
  loadFail: {
    try_again: '重試',
    load_fail: '讀取失敗',
    load_fail_desc: '數據加載失敗，請重試',
    IMEI_Not_Exist: 'IMEI不存在,請嘗試從正確入口進入',
    Project_Not_Exist:'發生異常,請聯繫客服(01)',
    commonError:'發生異常,請聯繫客服(01)',
  },
  settlement_Easy_and_convenient:"省心省力",
  settlement_Great_deal:"超值優惠",
  settlement_Safe_and_secure:"安全透明",
  settlement_Autopay_service_regulation:"自動續訂服務條款",
  settlement_Read:"查看",
  settlement_No_coupon:"暫無優惠",
  settlement_Subtotal:"原價",
  settlement_Coupon:"優惠",
  settlement_TOTAL:"實付金額",
  settlement_promotion_tip:"該活動與優惠券不可同享",
  settlement_coupon_tip:"該優惠券與活動不可同享",
  member_myFlow_noList:"沒有數據~",
  detail_se_content:"省心省力，可隨時關閉",
  Enter_Promo_code:"優惠碼",
  Enter_Promo_Coupon:"優惠券",
  settlement_Not_used_coupon:"張優惠券未使用",
  settlement_Available_coupon:"可用",
  settlement_Unavailable_coupon:"不可用",
  please_Enter_Promo_code:"請輸入優惠碼",
  please_Select_Coupon_use:　"請選擇您想要使用的優惠券",
  Buy_Now:"立即購買",
  Dont_Use_Any:"不使用優惠",
  flowDetail_unsubscribe: "退訂",
  flowDetail_unsubscribed: "已退訂",
  flowDetail_isCancelPackage: "是否退訂此套餐?",
  flowDetail_confirmAgreementUnsubscribe : "關閉自動續訂服務後，您就無法享受超低價格優惠了！真的要關閉嗎？",
  flowDetail_cancel: "取消",
  flowDetail_cancelSuccess: "退訂成功",
  packages_detail_promotion:"促銷活動",
  orderTips:{
        "iDay" : "天",
        "iDays" : "天",
        "iMonth" : "月",
        "iMonths" : "个月",
        'First_charge_discount':"首購<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol, 後續 %@money/%@periodSymbol 自動續費，可隨時關閉",
        'Monthly_discount':"每月勁省 %@saveMoney/%@period , 可隨時關閉",
        'Ordinary_monthly_package':"省心省力，可隨時關閉",
        "AlreadyPurchased":'很抱歉，每位用戶僅可同時享受壹個自動續訂優惠服務。請關閉“%@”自動續訂且待其使用完後再開通其他自動續訂服務。',
        "Contract_recommendation_First":'<label>開通連續包月,首購僅</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">可隨時關閉'
        +'<a class="btn">開通 ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>開通連續包月，每月僅</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">可隨時關閉'
        +'<a class="btn">開通 ></a></p>',
        "Contract_recommendation_General":"<label>開通連續包月</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">省心省力，可隨時關閉'
        +'<a href="javascript:;" class="btn">開通 ></a></p>',
        'BanlanceDoubleCheck':'確定使用余額支付？',
    },
    feedback: {
      title: "意見回饋",
      placeholder: "請輸入您想要去的國家或其他問題，我們將盡快滿足您的需求！",
      submit: "提交",
      submit_success: "提交成功",
      other_opinions: "其他意見",
    },
    view_country_input: '請輸入賬號',
    select_package: {
      title: '選擇套餐',
      allPackage: '全部套餐',
      type: '類別',
      flow: '流量', 
      month_package: '月包',
      flow_package: '流量包',
      time: '時長',
      period: '週期',
      auto_debit: '自動扣費說明',
      auto_subscribe: '自動訂閱',
      detail: '套餐詳情',
      carrier: '支援的營運商',
      country: '覆蓋的國家列表',
      notice: '購買須知',
  }
}